"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
var ColumnHeader = /** @class */ (function (_super) {
    __extends(ColumnHeader, _super);
    function ColumnHeader() {
        var _this = _super.call(this) || this;
        _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
        return _this;
    }
    ColumnHeader.prototype.handleHeaderClick = function (sortByFieldName) {
        if (this.props.headerClick) {
            this.props.headerClick(sortByFieldName);
        }
    };
    ColumnHeader.prototype.render = function () {
        var _this = this;
        var headerClasses = classNames({
            "sortable": true,
            "sorted": this.props.sort !== "unsorted",
            "hide": this.props.isHidden,
            "text-nowrap": this.props.headerNowrap
        });
        var chevron = this.props.sort !== "unsorted" ?
            this.props.sort === "asc" ?
                React.createElement(Icon_1.Icon, { icon: 'down' }) :
                React.createElement(Icon_1.Icon, { icon: 'up' })
            : '';
        return (
        // tslint:disable-next-line:jsx-no-lambda
        React.createElement("th", { className: headerClasses, onClick: function () { return _this.handleHeaderClick(_this.props.columnName); }, key: "col-head-" + (this.props.colIndex + 1) },
            React.createElement("div", { style: { display: "flex" } },
                this.props.header,
                chevron)));
    };
    return ColumnHeader;
}(React.Component));
exports.ColumnHeader = ColumnHeader;
//# sourceMappingURL=ColumnHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Table/ColumnHeader.js
// module id = 600
// module chunks = 1